module.exports = __webpack_public_path__ + "static/img/product_12.4e35c48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_12.jpg
// module id = Ra+C
// module chunks = 2